import React from 'react'
import PropTypes from 'prop-types'
import { isNil, isEmpty } from 'lodash'

import Component from '../common/Component'
import BulkApproveModal from './BulkApproveModal'
import approvingActions from '../../actions/BenefitsSetsApproval'
import connectIndex from '../../lib/connectIndex'
import identifierActions from '../../actions/BenefitsSetIdentifiers'

export class BulkApproveLink extends Component {
  static propTypes = {
    approveBenefitsSets: PropTypes.func.isRequired,
    includeSearchTermValidation: PropTypes.bool,
    index: PropTypes.func.isRequired,
    planCount: PropTypes.number.isRequired,
    planType: PropTypes.string,
    productLine: PropTypes.string,
    queryParams: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    resetApproveBenefitsSets: PropTypes.func,
    termValidated: PropTypes.string
  }

  static defaultProps = {
    includeSearchTermValidation: true,
    planType: 'Bulk'
  }

  constructor(props) {
    super(props)
    this.state = {
      ids: [],
      showModal: false
    }
  }

  get bulkApproveModal() {
    return (
      <BulkApproveModal
        handleClose={this.handleModalClose}
        handleApprove={this.handleApprove}
        isOpen={this.state.showModal}
        disabled={isEmpty(this.state.ids) || !this.validSearchTerm}
      >
        { this.modalMessage() }
      </BulkApproveModal>
    )
  }

  validSearchTerm = () => {
    if (!this.props.includeSearchTermValidation) { return true }

    const searchTerm = this.props.queryParams.search_term
    const regex = new RegExp(`${this.props.termValidated}:\\s+\\S+`)

    return !isNil(searchTerm) && regex.test(searchTerm)
  }

  modalMessage = () => {
    return `Are you sure you would like to approve all ${this.props.planCount} plans`
  }

  reset = () => {
    this.props.reset()
    this.props.resetApproveBenefitsSets()
  }

  approveAllPlans = async () => {
    if (isEmpty(this.state.ids)) {
      return
    }

    await this.props.approveBenefitsSets({ approved_benefits_set_ids: this.state.ids })
  }

  handleOnClick = () => {
    this.setIdentifiers()

    this.setState({ showModal: true })
  }

  handleModalClose = () => {
    this.setState({ showModal: false })
  }

  handleApprove = () => {
    this.approveAllPlans()
    this.setState({ showModal: false })
  }

  setIdentifiers = async () => {
    await this.props.index({ ...this.props.queryParams, product_line: this.props.productLine }).then((response) => {
      this.setState({ ids: response.records })
    })
  }

  render() {
    if (!this.validSearchTerm) {
      return null
    }

    const title = `Approve ${this.props.planType} Plans (${this.props.planCount})`

    return (
      <>
        <button
          className="button quiet-button small"
          title={title}
          onClick={this.handleOnClick}
          disabled={this.props.planCount === 0}
        >
          {title}
        </button>

        {this.bulkApproveModal}
      </>
    )
  }
}

export default connectIndex(
  BulkApproveLink,
  'benefitsSetIdentifiers',
  identifierActions,
  [],
  {},
  [
    { action: approvingActions.create.main, key: 'approveBenefitsSets' },
    { action: approvingActions.create.reset, key: 'resetApproveBenefitsSets' }
  ]
)
